"use client";
import { type MotionValue, motion, useMotionValueEvent } from "motion/react";
import { useState } from "react";
import { useSpotlightEffect } from "./use-spotlight-effect";

export function BackgroundPatternCrypto() {
    const { style, onMouseMove, onMouseLeave, setRef, isVisible, change } = useSpotlightEffect();

    return (
        <div
            className="relative h-full w-full"
            onMouseMove={(m) => {
                onMouseMove(m);
            }}
            onMouseLeave={() => {
                onMouseLeave();
            }}
            ref={setRef}
        >
            {isVisible && (
                <motion.div
                    className="h-full w-full"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 100 }}
                    transition={{ ease: "easeOut", duration: 1 }}
                >
                    {/* Color Gradient */}
                    <motion.div
                        className="absolute inset-0 bg-linear-to-r from-green-600 to-accent-flashy backdrop-blur-xl"
                        style={style}
                    />

                    {/* Random String */}
                    <motion.div className="absolute inset-0 mix-blend-overlay" style={style}>
                        <RandomString change={change} />
                    </motion.div>
                </motion.div>
            )}
        </div>
    );
}

function RandomString({ change }: { change: MotionValue<number> }) {
    const [randomString, setRandomString] = useState("");

    useMotionValueEvent(change, "change", () => {
        const str = generateRandomString(1500);
        setRandomString(str);
    });

    return (
        <div
            onMouseMove={() => {
                const str = generateRandomString(1500);
                setRandomString(str);
            }}
            className="absolute inset-x-0 h-full whitespace-pre-wrap break-words font-bold font-mono text-white text-xs"
        >
            {randomString}
        </div>
    );
}

const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const generateRandomString = (length: number) => {
    let result = "";
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};
